var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0662 8.99517C16.3591 8.70228 16.3591 8.22741 16.0662 7.93451C15.7733 7.64162 15.2985 7.64162 15.0056 7.93451L12.0004 10.9397L8.99518 7.93451C8.70229 7.64162 8.22742 7.64162 7.93452 7.93451C7.64163 8.22741 7.64163 8.70228 7.93452 8.99517L10.9397 12.0004L7.93451 15.0056C7.64162 15.2985 7.64162 15.7733 7.93451 16.0662C8.22741 16.3591 8.70228 16.3591 8.99517 16.0662L12.0004 13.061L15.0056 16.0662C15.2985 16.3591 15.7734 16.3591 16.0663 16.0662C16.3591 15.7733 16.3591 15.2985 16.0663 15.0056L13.061 12.0004L16.0662 8.99517Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.86020ef017d17a848a5101682bd717b2.svg";
export { ForwardRef as ReactComponent };